import React, { useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Collapse,
  IconButton,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import WeekPickerPopover from "../../../../common-utilities/core/week-picker";
import AutocompleteComponent from "../../../../common-utilities/core/styled-autocomplete";
import FinancialYearDropdown from "../../../../finance/components/home/financial-year-dropdown";
import CustomFilterComponent from "./filters";
import { MONTHS } from "../../../../common-utilities/utils/constants";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
const FiltersPanel = ({
  filterOptions,
  handleFilterChange,
  filters,
  setFilters,
  FILTER_TYPES,
  searchHandler,
  resetHandler,
}) => {
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  return (
    <Box component={Paper} sx={{ p: 2, mb: 3, borderRadius: 1 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item sx={{ display: "flex" }} md={8}>
          <Typography variant="h6" sx={{ mr: 2 }}>
            Filters:{" "}
          </Typography>
          <Grid item xs={12} sm={4} md={4}>
            <WeekPickerPopover
              value={filters?.week || null}
              onWeekSelect={(data) => {
                if (data) {
                  setFilters((prev) => ({
                    ...prev,
                    week: {
                      startDate: data.startDate,
                      endDate: data.endDate,
                    },
                  }));
                } else {
                  setFilters((prev) => ({
                    ...prev,
                    week: null,
                  }));
                }
              }}
            />
          </Grid>

          <FormControlLabel
            control={
              <Checkbox
                checked={filters?.isActive}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    isActive: e.target.checked,
                  }))
                }
              />
            }
            label="Is Active categories"
            sx={{ ml: 2 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={filters?.critical}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    critical: e.target.checked,
                  }))
                }
              />
            }
            label="Is Critical"
            sx={{ ml: 2 }}
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            size="small"
            sx={{ borderRadius: 50, mr: 3 }}
            startIcon={<SearchIcon />}
            onClick={searchHandler}
          >
            Search
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{ borderRadius: 50, mr: 3 }}
            startIcon={<RestartAltIcon />}
            color="warning"
            onClick={() => {
              setShowAdvancedFilters(false);
              resetHandler();
            }}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            size="small"
            color="info"
            sx={{ borderRadius: 50 }}
            endIcon={showAdvancedFilters ? <ExpandLess /> : <ExpandMore />}
            onClick={() => setShowAdvancedFilters((prev) => !prev)}
          >
            {showAdvancedFilters ? "Collapse Filters" : "Expand Filters"}
          </Button>
        </Grid>
      </Grid>

      <Collapse in={showAdvancedFilters}>
        <Box mt={3}>
          <CustomFilterComponent
            filterOptions={filterOptions}
            onFilterChange={handleFilterChange}
            filterTypes={FILTER_TYPES}
          />
        </Box>
      </Collapse>
    </Box>
  );
};

export default FiltersPanel;
